// Investor bank-accounts directory parser — DTO (wire shape) → view
// model. The seam every consumer must respect. Containers / components
// / composables never read a snake_case field directly.

import type {
  BankAccountInvestorDto,
  BankAccountListResponseDto,
  BankAccountRowDto,
} from './bankAccountsDirectoryContracts'
import type {
  BankAccountInvestor,
  BankAccountRow,
  BankAccountsDirectoryListResponse,
} from '../types/bankAccountsDirectoryTypes'

function parseInvestor(dto: BankAccountInvestorDto): BankAccountInvestor {
  return {
    id: String(dto.id ?? ''),
    investorType: String(dto.investorType ?? dto.investor_type ?? ''),
    firstName: dto.firstName ?? dto.first_name ?? null,
    lastName: dto.lastName ?? dto.last_name ?? null,
  }
}

export function parseBankAccountRow(dto: BankAccountRowDto): BankAccountRow {
  return {
    id: String(dto.id ?? ''),
    bankName: String(dto.bankName ?? dto.bank_name ?? ''),
    accountHolderName: String(dto.accountHolderName ?? dto.account_holder_name ?? ''),
    accountNumber: String(dto.accountNumber ?? dto.account_number ?? ''),
    ifscCode: dto.ifscCode ?? dto.ifsc_code ?? null,
    iban: dto.iban ?? null,
    swiftCode: dto.swiftCode ?? dto.swift_code ?? null,
    currencyCode: String(dto.currencyCode ?? dto.currency_code ?? ''),
    accountStatus: (dto.accountStatus ??
      dto.account_status ??
      '') as BankAccountRow['accountStatus'],
    rejectionReason: dto.rejectionReason ?? dto.rejection_reason ?? null,
    createdAt: String(dto.createdAt ?? dto.created_at ?? ''),
    investor: parseInvestor(dto.investor),
  }
}

export function parseBankAccountsDirectoryListResponse(
  dto: BankAccountListResponseDto,
): BankAccountsDirectoryListResponse {
  return {
    rowsCount: Number(dto.rowsCount ?? dto.rows_count ?? 0),
    rows: (dto.rows ?? []).map(parseBankAccountRow),
  }
}
